<template>
	<div>
      <v-container grid-list-xl class="noStatic linkUsers">
        <v-layout row wrap>
          <v-flex lg3 style="padding: 0px !important;margin-right: 12px !important;">
            <br />
            <label class="blackLabel">User Type:</label>
            <v-select :items="linkType" @input="fncFetchUsers" v-model="linkTypeSingle" item-value="id" label="User Type" solo></v-select>
          </v-flex>
          <v-flex lg3 style="padding: 0px !important">
            <br />
            <label class="blackLabel">&nbsp;</label>
            <v-text-field append-icon="search" label="Search" v-if="userLinks != ''" solo single-line v-model="search"></v-text-field><br />
          </v-flex>
          <!--:pagination.sync="pagination"-->
          <v-flex lg12 style="padding: 0px !important">
            <v-data-table loading="true" :headers="headers" v-if="userLinks != ''" :items="userLinks" :rows-per-page-items="[20,40,60,80,100]" :search="search" disable-initial-sort class="elevation-1 linkTableMediumSmall">
              <template slot="items" slot-scope="props">
                <td width="10%"><v-switch v-model="props.item.linked" @click="fncSaveLink(props.item.id, props.item.linked, props.item.companyName, props.item.fullname, props.item.type )"></v-switch></td>
                <!--<td width="90%" v-if="props.item.companyName != ''">{{ props.item.companyName }} - {{ props.item.fullname }}</td>-->
                <td width="90%">{{ props.item.fullname }}</td>
              </template>
            </v-data-table>
            </v-flex>
            <!--<p v-if="userLinks == '' && linkTypeSingle != '' && loaded == false">Loading</p>-->
            <v-flex lg12>
              <center><img class="imgLoader" style="padding-top: 0% !important" src="../../shared/assets/images/3dloader.gif" v-if="userLinks == '' && linkTypeSingle != '' && loaded == false" /></center>
            </v-flex>
            <p v-if="userLinks == '' && linkTypeSingle != '' && loaded == true">No users / companies could be found to link / unlink</p>
            <v-layout row wrap class="pl-4 pr-4 pt-4 pb-4">
              <div class="pl-4 pr-1 pb-2 buttonHolder">
                <div style="float: right">
                  <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
                </div>
              </div>
            </v-layout>
</v-layout>
</v-container>	
      </div>
</template>

<script>

	import { mapGetters } from 'vuex';
    
	export default {
        name: 'UserNotifications',
        components: {},
		data () {
          return {	
              search: '',
              pagination: { 'sortBy': 'fullname', 'ascending': true },
              // linkTypeSingle: this.$store.getters.globalModalParams.userType,
              linkTypeSingle: this.$store.getters.globalModalParams.customer == true ? 2 : '',
              linkType: [
                /*{ id: 1, text: 'Manufacturer Users' },
                { id: 2, text: 'Customer Users' },
                { id: 3, text: 'Specifier Users' },
                { id: 4, text: 'Public Users' },
                { id: 6, text: 'Vendor Users' },*/
              ],
              currentUserCompany: this.$store.getters.currentUserCompany,
              headers: [
                { text: 'Override', value: '', width: '10%' },
                { text: 'Name', value: 'fullname', width: '90%' }                
              ],	
              loaded: false
			}
		},
		methods: {
          fncHideModal() {
                this.linkTypeSingle = '';
                this.$store.commit('hideModal');
            },
            fncFetchUsers() {              
              this.$store.dispatch({
                type: 'fncFetchLinkUsers',
                userType: this.linkTypeSingle,
                userId: this.globalModalParams.userId,
                linkType: this.globalModalParams.userType
              })              
            },
            fncSaveLink(userId, linked, isCompany, isUser, type) {              
              var linkType = 'unlink';
              if (linked == 0 || linked == false) {
                linkType = 'link';
              }    

              var saveType = 'User';
              
              if ( isCompany != '' && isUser != '' ) {
                saveType = 'User';
              }

              if (this.linkTypeSingle == 2) {                
                saveType = type;
              }
              
              this.$store.dispatch({
                type: 'fncSaveUserLink',
                child: userId,
                parent: this.globalModalParams.userId,
                linkType: linkType,
                userType: this.globalModalParams.userType,
                saveType: saveType
              })
            }
		},
		computed: {
			...mapGetters([
                'objAuthorize',
                'globalModalParams',
                'userLinks'                
			])
        },
        created() {
          this.linkType = [{ id: 1, text: this.objAuthorize.manu_user_alias }];

          if (this.objAuthorize.privileges.indexOf('HIDE_CUSTOMER_USERS') == -1) {
            this.linkType.push({ id: 2, text: this.objAuthorize.customer_user_alias });
          }

          if (this.objAuthorize.privileges.indexOf('HIDE_SPECIFIER_USERS') == -1) {
            this.linkType.push({ id: 3, text: this.objAuthorize.specifier_user_alias });
          }

          if (this.objAuthorize.privileges.indexOf('HIDE_SPECIFIER_USERS') == -1) {
            this.linkType.push({ id: 4, text: this.objAuthorize.public_user_alias });
          }

          if (this.objAuthorize.privileges.indexOf('VENDOR_MODULE') != -1) {
            this.linkType.push({ id: 6, text: 'Vendor Users' });
          }

          if (this.$store.getters.globalModalParams.customer == true ) {
            this.linkTypeSingle = 2;
            this.fncFetchUsers();
          }
        },
        watch: {
          userLinks() {
            this.loaded = true;
          }
        }
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
</style>